import { createFileRoute, notFound } from "@tanstack/react-router";
import { type WorkOrderId, workOrderIdSchema } from "../lib/workIds";

export const Route = createFileRoute("/_app/work-orders/$workOrderId")({
  params: {
    parse: (params): { workOrderId: WorkOrderId } => {
      const parsed = workOrderIdSchema.safeParse(params.workOrderId);
      if (!parsed.success) throw notFound();
      return { workOrderId: parsed.data };
    },
  },
  component: () => null,
});
